import { attr, belongsTo } from '@ember-data/model';
import BaseModel from 'volta/models/base-model';
import { Type } from '@warp-drive/core-types/symbols';
import SkuModel from './sku';
import OnHandSourcings from './constants/on-hand-sourcing';

import type { TOnHandSourcing } from './types/planning-settings';

export default class SkuSupplyAlternative extends BaseModel {
  @attr('string') declare skuId: string;
  @attr('string') declare alternativeSkuId: string;
  @attr('number', { defaultValue: 1 }) declare priority: number;
  @attr('boolean', { defaultValue: true }) declare isActive: boolean;
  @attr() declare onHandSourcing: TOnHandSourcing;
  @belongsTo('sku', { async: false, inverse: null }) declare sku: SkuModel;
  @belongsTo('sku', { async: false, inverse: null }) declare alternativeSku: SkuModel;

  get onHandSourcingLabelKey() {
    return OnHandSourcings[this.onHandSourcing];
  }

  [Type] = 'sku-supply-alternative' as const;
}
